import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { object, string } from "yup";

import { resetPassword } from "../../../Api/Signin/Signin.Api";
import { Theme } from "../../../Style/Theme";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import { PasswordInput } from "../../atoms/Input/PasswordInput";
import { LoadingButtonType } from "../../atoms/LoadingButton/LoadingButton";
import { SubHeader4 } from "../../atoms/Typography/SubHeader/SubHeader";
import { PasswordStrengthField } from "../PasswordStrengthField/PasswordStrengthField";
import { FormItemsWrap } from "../Wrap/Wrap";

export const SetPasswordForm = ({
  onClick,
  type,
  t,
  token,
  state,
  username,
  expireTime,
}) => {
  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const { control, handleSubmit, getValues, watch, setError, formState } =
    useForm({
      defaultValues: {
        password: "",
        confirmPassword: "",
      },
      mode: "onChange",
      resolver: yupResolver(
        object({
          password: string()
            .required(t("validation:required-field"))
            .test("passwordCriteria", "", function (value) {
              // true means validated
              let flag = true;

              const isValidPassword =
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
                  value,
                );
              if (!isValidPassword) {
                // false means rules violated
                flag = false;
              }
              return flag;
            }),
          confirmPassword: string()
            .required(t("validation:required-field"))
            .test(
              "testPasswordMatching",
              t("validation:password-do-not-match"),
              function (value) {
                let flag = true;
                if (value !== getValues("password")) {
                  flag = false;
                }
                return flag;
              },
            ),
        }),
      ),
    });

  const onSubmit = async (formData) => {
    try {
      startLoading({ btnName: "username" });
      resetPassword({
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        emailAddress: username,
        token: token,
        expireTime: expireTime,
      }).then((d) => {
        if (d.type == 0) {
          onClick("pass", formData.password);
        } else if (d.message === "same-password") {
          setError("password", {
            message: t("validation:same-password"),
          });
          onClick("fail");
        }else if (d.message === "link-expired") {
          onClick("link-expired");
        } else if (d.type == 3 && d.message) {
          setError("password", {
            message: t(d.message, { ns: "validation" }),
          });
          onClick("fail");
        } else if (d.message) {
          setError("password", {
            message: t("validation:server-error"),
          });
        }
        stopLoading();
      });
    } catch (error) {
      console.log("error", error);
      t("invalid-password", { ns: "validation" });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormItemsWrap gap={"32px"}>
        <PasswordStrengthField
          t={t}
          control={control}
          label={
            type === "reset"
              ? t("common:form.enter-new-password")
              : "Create a Password"
          }
          name={"password"}
          password={watch()?.password}
        />
        <PasswordInput
          required={true}
          control={control}
          isInherit={true}
          label={
            type === "reset"
              ? t("common:form.confirm-new-password")
              : "Confirm Password"
          }
          name={"confirmPassword"}
        />
        {type !== "reset" && (
          <FormItemsWrap width={"349px"} direction={"row"}>
            <SubHeader4
              text={
                <>
                  By creating an account, I state that I have read and
                  understood the
                  <span
                    style={{
                      color: Theme.palette.text.blue,
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    <span> terms </span>
                    <span
                      style={{
                        color: "black",
                      }}
                    >
                      and{" "}
                    </span>
                    <span>conditions.</span>
                  </span>
                </>
              }
            />
          </FormItemsWrap>
        )}

        <LoadingButtonType
          loading={LoadingState.visible}
          type="submit"
          variant="primaryBlue"
        >
          {type === "reset"
            ? t("common:button.confirm-password")
            : "Create Account"}
        </LoadingButtonType>
      </FormItemsWrap>
    </form>
  );
};
